export enum DriverActivityType {
  REST = 'Rest',
  DRIVE = 'Drive',
  NOT_AVAILABLE = 'Not available',
  AVAILABLE = 'Available',
  WORK = 'Work',
  PAID_REST = 'Paid Rest',
}

export const TACHO_FILE_SOURCE_LABELS = {
  SCANIA: 'Scania',
  TRACKSYS: 'Tracksys',
  MAN: 'Man',
  VOLVO: 'Volvo',
} as const

export const isTachoFileSourceLabel = (
  source: string
): source is keyof typeof TACHO_FILE_SOURCE_LABELS =>
  source in TACHO_FILE_SOURCE_LABELS

export const formatTachoFileSource = (source: string | null | undefined) =>
  source && isTachoFileSourceLabel(source)
    ? TACHO_FILE_SOURCE_LABELS[source]
    : source ?? '-'

export type TachoFileType = 'driver' | 'vehicle' | 'unknown'

/** Tacho .ddd files are prefixed C_/C- (driver card) or M_/M- (vehicle unit). */
export const getTachoFileType = (fileName: string): TachoFileType => {
  const upper = fileName.toUpperCase()
  if (upper.startsWith('M_') || upper.startsWith('M-')) return 'vehicle'
  if (upper.startsWith('C_') || upper.startsWith('C-')) return 'driver'
  return 'unknown'
}

export const isDddFile = (fileName: string): boolean =>
  fileName.split('.').pop()?.toLowerCase() === 'ddd'
